define('core/templates/postMediaTwitterContent',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<meta name=\"twitter:widgets:csp\" content=\"on\">\n<blockquote class=\"twitter-tweet\" data-theme=\""
    + alias2(alias1((depth0 != null ? depth0.theme : depth0), depth0))
    + "\" data-link-color=\""
    + alias2(alias1((depth0 != null ? depth0.linkColor : depth0), depth0))
    + "\" lang=\""
    + alias2(alias1((depth0 != null ? depth0.language : depth0), depth0))
    + "\">\n<a href=\""
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "\"></a>\n</blockquote>\n<script src=\"//platform.twitter.com/widgets.js\"></script>\n";
},"useData":true})

});
